import { render, staticRenderFns } from "./CorrelationCard.vue?vue&type=template&id=51349082"
import script from "./CorrelationCard.vue?vue&type=script&lang=js"
export * from "./CorrelationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports